import { useEffect } from "react";
import useGlobalProvider from "../../providers/globalProvider";
import apiClient, { handleApiError } from "../../apiClient";
import { useQuery } from "@tanstack/react-query";

export const UTENTI_KEY = "utenti";

export function useUtenti(
  comuneId,
  { pageSize, page, query, sort, populate, useSpecialQuery },
  useSetLoading = true
) {
  const { setLoading, setMessage, loading } = useGlobalProvider();
  const params = {
    pageSize,
    page,
    query,
    sort,
    populate,
    useSpecialQuery: useSpecialQuery ? "1" : "0",
  };

  const initialData = {
    data: [],
    meta: {
      totalItems: 0,
      currentPage: 0,
      pageSize: 0,
      totalPages: 0,
      query: {},
      sort: { createdAt: -1 },
    },
  };

  const {
    isLoading,
    isFetching,
    data: utenti,
  } = useQuery({
    queryKey: [`${UTENTI_KEY}-${comuneId}-list`, params],
    queryFn: fetch,
    placeholderData: initialData,
    staleTime: 60 * 1000, // 1 minute
    keepPreviousData: true,
    enabled: !!comuneId && !loading,
    onError: (err) =>
      handleApiError(
        err,
        setMessage,
        "Errore durante il caricamento degli utenti"
      ),
  });

  async function fetch() {
    const { data } = await apiClient.utente.getAll(comuneId, params);
    return data;
  }

  useEffect(() => {
    if (useSetLoading) {
      setLoading(isLoading || isFetching);
    }
  }, [isLoading, isFetching]);

  return { utenti, isFetching, isLoading };
}

export function useUtente(comuneId, id, useSetLoading = true) {
  const { setLoading, setMessage, loading } = useGlobalProvider();

  const {
    isLoading,
    isFetching,
    fetchStatus,
    data: utente,
  } = useQuery({
    queryKey: [`${UTENTI_KEY}-${comuneId}-item`, { id }],
    queryFn: fetch,
    staleTime: 60 * 1000,
    enabled: !!id && !!comuneId && !loading,
    onError: (err) =>
      handleApiError(
        err,
        setMessage,
        `Errore durante il caricamento dell'utente con id ${id}`
      ),
  });

  async function fetch() {
    const { data } = await apiClient.utente.getById(comuneId, id);
    return data;
  }

  useEffect(() => {
    if (useSetLoading) {
      setLoading((isLoading && fetchStatus !== "idle") || isFetching);
    }
  }, [isLoading, isFetching, fetchStatus]);

  return { utente, isFetching, isLoading: isLoading && fetchStatus !== "idle" };
}
